import React from 'react';

const Content = () => {
  return (
    <div className='py-10'>
      <div className='container mx-auto flex flex-col items-center px-4 text-center lg:px-16'>
        {/* Subtitle */}
        <p className='mb-8 text-3xl font-bold text-gray-700 md:text-4xl'>
          Elevate Your Stay: Seamless Hotel Booking with BluelagoonTravels
        </p>

        {/* Main Heading */}

        <h1 className='mb-10 text-3xl font-extrabold leading-snug text-gray-900 md:text-6xl'>
          Welcome to <span className=''>BluelagoonTravels</span> - Where
          <br className='hidden md:block' /> Every Stay is a Grand Experience!
        </h1>

        {/* Description */}
        <p className='text-justify text-gray-700 md:text-center'>
          At BluelagoonTravels, we understand that finding the perfect accommodation is the
          cornerstone of any memorable trip. Whether you’re a business traveler seeking convenience
          or a leisure explorer in pursuit of luxury, our hotel booking services are designed to
          cater to your every need. Join us as we guide you through the art of effortless hotel
          booking, ensuring that your stay is nothing short of extraordinary.
        </p>
      </div>
    </div>
  );
};

export default Content;
